import { CButton } from "@coreui/react";
import React, { useState, useEffect, useCallback } from "react";
import { useTheme } from "src/providers/Theme";

export const Drawer = ({ children, isOpen, defaultOpen = false, onClose, className = '' }) => {
  const [open, setOpen] = useState(Boolean(defaultOpen || isOpen));
  const {color} = useTheme();
  // Keep internal state in sync when used as a controlled component
  useEffect(() => {
    if (typeof isOpen === 'boolean') setOpen(isOpen);
  }, [isOpen]);

  const close = useCallback(() => {
    // If `isOpen` is provided (controlled), we don't change internal state
    if (typeof isOpen !== 'boolean') setOpen(false);
    if (typeof onClose === 'function') onClose();
  }, [isOpen, onClose]);

  // Provide `onClose` to child components so they can trigger closing
  const childrenWithOnClose = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { onClose: close });
    }
    return child;
  });

  return (
    <>
      {open && (
        <div
          className="drawer-backdrop"
          onClick={close}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1040 }}
          aria-hidden="true"
        />
      )}

      <div
        className={`fixed-bottom border-1 ${className}`}
        style={{
          transform: open ? 'translateY(0)' : 'translateY(100%)',
          transition: 'transform .25s ease-in-out',
          zIndex: 1050,
        }}
        aria-hidden={!open}
      >
        <div className={`bg-${color} border p-4`} style={{ borderRadius: '15px 15px 0 0', position: 'relative' }}>
          <CButton
            color={color}
            type="button"
            aria-label="Close drawer"
            onClick={close}
            style={{
              position: 'absolute',
              right: 12,
              top: 12,
              background: 'transparent',
              border: 'none',
              fontSize: 22,
              cursor: 'pointer',
              lineHeight: 1,
            }}
          >
            ×
          </CButton>

          {childrenWithOnClose && React.Children.count(childrenWithOnClose) > 0 ? (
            childrenWithOnClose
          ) : (
            <>
              <h5>Drawer Component</h5>
              <p>This is a placeholder for the Drawer component content.</p>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Drawer;